import React from 'react';
import PropTypes from 'prop-types';

export default class Input extends React.Component {
  constructor() {
    super();

    this.state = {
      valid: false,
      hasBlurred: false,
    };

    this.onChange = this.onChange.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  onChange(e) {
    if (this.props.required) {
      this.validateInput(e.target);
    }

    if (this.props.onChange) {
      this.props.onChange(e);
    }
  }

  onBlur(e) {
    this.setState({hasBlurred: true});

    if (this.props.required) {
      this.validateInput(e.target);
    }
  }

  validateInput(target) {
    const valid = target.checkValidity(target);

    if (valid) {
      this.setState({valid: true});

      if (typeof this.props.onValid === 'function') {
        this.props.onValid();
      }
    } else {
      this.setState({valid: false});
    }
  }

  getLabelClass() {
    let labelClass = 'form__desc-label';

    if (this.props.helpText) {
      labelClass += ' form__desc-label--no-spacing';
    }

    return labelClass;
  }

  render() {
    return (
      <div className="form__group" data-required={this.props.required}>
        {
          this.props.label ?
          <label className={this.getLabelClass()}><strong>{this.props.label}</strong></label> : null
        }
        {
          this.props.helpText ?
          <small className="form__help-text">{this.props.helpText}</small> : null
        }
        <input {...this.props} onBlur={this.onBlur} onChange={this.onChange} />
        {
          this.props.required && (this.state.hasBlurred && !this.state.valid) ?
          <label className="form__error-label">{this.props.invalidMsg}</label> : null
        }
      </div>
    );
  }
}

Input.propTypes = {
  onValid: PropTypes.any,
  onChange: PropTypes.any,
  required: PropTypes.bool,
  label: PropTypes.string,
  invalidMsg: PropTypes.string,
};
